import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { eventCategory } from "../../utils/constant";
import { readMore } from "../../utils/utilities";
import { listRsvpState } from "../../utils/constant";
import parse from "html-react-parser";
import moment from "moment";
import BaseLayout from "../../components/BaseLayout";
import Header from "../../components/Header";
import Tabs from "../../components/Tabs";
import NotFound from "../../components/NotFound";
import ApiUtils from "../../utils/api_utils";
import * as Assets from "../../utils/svg_assets";
import * as PageRoutes from "./../../utils/route_pages";
import "./style.scss";

const EventPage = (props) => {
  const { getData, listEvent } = props;
  const navigate = useNavigate();
  const [isActive, setIsActive] = useState(1);
  const [type, setType] = useState("is_today");

  useEffect(() => {
    getData(type);
  }, [type]);

  const onChangeTabs = (tabActive) => {
    setIsActive(tabActive);

    if (tabActive !== 1) {
      setType("is_upcoming");
    } else {
      setType("is_today");
    }
  };

  const SectionTab = () => {
    return (
      <div className="d-flex wrapper-tab align-items-center p-0">
        {eventCategory.map((cat, index) => (
          <Tabs
            id={cat.id}
            key={index}
            name={cat.name}
            isActive={isActive}
            onClick={() => onChangeTabs(cat.id)}
          />
        ))}
      </div>
    );
  };

  const getRsvpState = (state, key) => {
    const result = listRsvpState.filter((val) => state === val.state);
    return result.length > 0 ? result[0][key] : null;
  };

  const isAttendingOnStateUpcoming = (rsvpState) => {
    return type === "is_upcoming" && rsvpState === "attending";
  };

  const isAttended = (rsvpState) => {
    return type === "is_today" && rsvpState === "attended";
  };

  const SectionRsvpItem = (data) => {
    const {
      id,
      thumbnail,
      name,
      description,
      start,
      payment_type: paymentType,
      rsvp_state: rsvpState,
    } = data.data;
    return (
      <div
        className="card-feeds mb-3"
        onClick={() => navigate(`${PageRoutes.eventDetail}/${id}?type=${type}`)}
      >
        <div className="position-relative">
          <div
            style={{
              backgroundSize: "cover",
              height: "170px",
              backgroundPosition: "center center",
              backgroundImage: `url(${ApiUtils.validateImgUrl({
                url: thumbnail,
              })}`,
            }}
          />
          <span className="badge">{paymentType === 1 ? "Free" : "Paid"}</span>
        </div>
        <div className="m-3 d-flex">
          <div className="fs-18 mr-1">
            <div className="text-center">{moment(start).format("D")}</div>
            <div>{moment(start).format("MMM")}</div>
          </div>
          <div>
            <div className="mb-1 fs-18 font-bold">{name}</div>
            <div>{parse(readMore(description, 100))}</div>
          </div>
        </div>
        <div className="m-2">
          <button
            className="btn btn-success w-100 border-0"
            style={{
              backgroundColor: isAttendingOnStateUpcoming(rsvpState)
                ? "#EAEAEA"
                : getRsvpState(
                    type === "is_today" && rsvpState === "not_attending"
                      ? "attending"
                      : rsvpState,
                    "color"
                  ),
              color: isAttendingOnStateUpcoming(rsvpState)
                ? "#1A1A1A"
                : isAttended(rsvpState)
                ? "grey"
                : "",
            }}
          >
            {isAttendingOnStateUpcoming(rsvpState) ? (
              <div>
                <img
                  src={Assets.iconCheck}
                  width={20}
                  className="mr-xs"
                  alt="Icon Check"
                />
                You have submitted RSVP
              </div>
            ) : type === "is_today" && rsvpState === "not_attending" ? (
              getRsvpState("attending", "label")
            ) : (
              <>
                {isAttended(rsvpState) ? (
                  <img
                    src={Assets.iconCheck}
                    width={20}
                    className="mr-xs"
                    alt="Icon Check"
                  />
                ) : (
                  ""
                )}
                {getRsvpState(rsvpState, "label")}
              </>
            )}
          </button>
        </div>
      </div>
    );
  };

  return (
    <div id="event-page">
      <BaseLayout
        bottomNavIndex={1}
        isCustom={true}
        show_menu={false}
        header={
          <Header
            toPath={PageRoutes.home}
            page="Event"
            bgImg={`${process.env.PUBLIC_URL + "/banner/event.svg"}`}
          />
        }
      >
        <>
          <SectionTab />
          <div className="p-bottom">
            {listEvent.length > 0 ? (
              listEvent.map((event, index) => {
                return <SectionRsvpItem key={index} data={event} />;
              })
            ) : (
              <NotFound
                img={Assets.iEventNotFound}
                title="There is no event yet"
                subTitle="We are still building amazing events for you."
              />
            )}
          </div>
        </>
      </BaseLayout>
    </div>
  );
};

const mapStateToProps = (state) => ({
  listEvent: state.EventSM.listEvent,
});

const mapDispatchToProps = (dispatch) => ({
  getData: dispatch.EventSM.getData,
});

export default connect(mapStateToProps, mapDispatchToProps)(EventPage);
